























































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  getdatalist,
  insertexpert,
  getexpertinfo,
  updateexpert,
} from "@/api/expertmanage";
import Pagination from "@/components/Pagination/index.vue";
@Component({
  name: "guideManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery);
  }
  private currtentpage = 1;
  private total: number = 0;
  private formObj = {
    dialogVisible: false,
  };
  private options = [
    {
      key: "启用",
      value: 1,
    },
    {
      key: "禁用",
      value: 0,
    },
  ];
  private tableData = {};
  private currentPage: number = 1;
  private value: boolean = true;
  private isloading = true;
  private isuse = 1;
  private addParms: any = {
    username: "",
    loginname: "",
    identity: "",
    isuse: 1,
    psd: "",
    copesd: "",
    sex: "",
    age: "",
  };
  private isuseoptions = [
    {
      label: "禁用",
      value: 0,
    },
    {
      label: "启用",
      value: 1,
    },
  ];
  private sexoptions = [
    {
      label: "男",
      value: 0,
    },
    {
      label: "女",
      value: 1,
    },
    {
      label: "性别不详",
      value: 3,
    },
  ];
  private editparms: any = {
    // name: "",
    // description: "",
    // isuse: "",
    // id: "",
    // isdelete: "",
  };
  private listQuery = {
    name: "",
    page: 1,
    limit: 10,
  };
  // 自定义校验规则
  private validatePass2(rule, value, callback) {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.addParms.psd) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  }
  // 表单校验规则
  private rules = {
    username: [
      { required: true, message: "请输入用户名称", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    loginname: [
      { required: true, message: "请输入登录名称", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    identity: [
      { required: true, message: "请填写证件号码", trigger: "blur" },
      {
        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        message: "证件号码格式有误！",
        trigger: "blur",
      },
    ],
    psd: [
      { required: true, message: "请输入密码", trigger: "blur" },
      { min: 1, message: "密码最少大于1位", trigger: "blur" },
    ],
    copesd: [
      {
        required: true,
        validator: this.validatePass2,
        trigger: "blur",
      },
    ],
  };

  // 获取列表
  private async getList(params: any) {
    await getdatalist(params)
      .then((res) => {
        if (res.code === 200) {
          this.isloading = false;
          res.data.items.forEach((item: any) => {
            item.isuse = item.isuse == 1 ? true : false;
          });
          this.tableData = res.data;
          this.total = res.data.total;
          this.listLoading = false;
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  private async changeSwitch(parms: any) {
    const usestate = parms.isuse === true ? 1 : 0;
    const param = {
      id: parms.id,
    };
    await getexpertinfo(param).then(async (res) => {
      if (res.code === 200) {
        this.editparms = res.data;
        this.editparms.isuse = usestate;
        this.editparms.isdelete = 1;
        await updateexpert(this.editparms).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: "状态更改成功",
              type: "success",
            });
            this.editparms = {};
          } else {
            this.$message({
              message: "状态更改失败",
              type: "warning",
            });
          }
        });
      }
    });
  }
  private async deletedata(params: any) {
    let paramid = { id: params.id };
    this.getinfo(paramid);
    let param = {
      age: this.addParms.age,
      id: params.id,
      identity: this.addParms.identity,
      isuse: this.addParms.isuse,
      loginname: this.addParms.loginname,
      password: this.addParms.psd,
      sex: this.addParms.sex,
      username: this.addParms.username,
      isdelete: 0,
    };
    this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      await updateexpert(param).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList(this.listQuery);
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
          });
        }
      });
    });
  }
  private onSubmit() {
    this.getList(this.listQuery);
  }
  private clearSearch() {
    this.listQuery.name = "";
    this.getList(this.listQuery);
  }
  private onCreatItem() {
    this.addParms = {
      username: "",
      loginname: "",
      identity: "",
      isuse: 1,
      psd: "",
      copesd: "",
      sex: "",
      age: "",
    };
    this.editparms = {};
    this.formObj.dialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.ruleForm as any).resetFields();
    });
  }
  private async getinfo(parm) {
    await getexpertinfo(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false;
        let resdata = res.data;
        this.addParms = {
          username: resdata.username,
          loginname: resdata.loginname,
          identity: resdata.identity,
          age: resdata.age,
          isuse: resdata.isuse,
          psd: resdata.password,
          copesd: resdata.password,
          sex: resdata.sex,
        };
        this.editparms.id = resdata.id;
      }
    });
  }
  private async editItem(params: any) {
    const parm = { id: params };
    this.getinfo(parm);
    this.formObj.dialogVisible = true;
  }

  private handleClose(done: any) {
    this.formObj.dialogVisible = false;
    this.addParms = {
      name: "",
      description: "",
      isuse: "",
    };
  }

  private async subMitData() {
    const form = this.$refs.ruleForm as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        if (this.editparms.id) {
          let param = {
            age: this.addParms.age,
            id: this.editparms.id,
            identity: this.addParms.identity,
            isuse: this.addParms.isuse,
            loginname: this.addParms.loginname,
            password: this.addParms.psd,
            sex: this.addParms.sex,
            username: this.addParms.username,
            isdelete: 1,
          };
          await updateexpert(param).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("修改成功");
              this.getList(this.listQuery);
            }
          });
        } else {
          let param = {
            username: this.addParms.username,
            loginname: this.addParms.loginname,
            password: this.addParms.psd,
            isuse: this.addParms.isuse,
            age: this.addParms.age,
            sex: this.addParms.sex,
            identity: this.addParms.identity,
          };
          await insertexpert(param).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              this.getList(this.listQuery);
              this.$message.success("添加成功");
            } else if (res.code === 201) {
              this.$message.error("该点评人已存在,请检查后添加");
            }
          });
        }
      } else {
        return false;
      }
    });
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
